import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/acm.png'


const _withScopeId = n => (_pushScopeId("data-v-288d71b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-bar" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: _imports_0,
    alt: "MYOJ logo"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "MYOJ")
], -1))

import { routes } from "@/router/routes";
import { useRoute, useRouter } from "vue-router";
import { computed, ref } from "vue";
import { useStore } from "vuex";
import checkAccess from "@/access/checkAccess";
import message from "@arco-design/web-vue/es/message";
import { MyAxios } from "@/plugins/axios";


export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalHeader',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const selectedKeys = ref(["/"]);
const store = useStore();
const my = ref(store.state.user?.loginUser?.userName);

// console.log(store.state);
//过滤后展示的路由菜单
const visibleRoutes = computed(() => {
  return routes.filter((item, index) => {
    if (item.meta?.hide) {
      return false;
    }
    if (
      !checkAccess(store.state.user.loginUser, item?.meta?.access as string)
    ) {
      return false;
    }
    return true;
  });
});

router.afterEach((to) => {
  my.value = store.state.user?.loginUser?.userName;
  selectedKeys.value = [to.path];
});
const doMenuClick = (key: string) => {
  router.push({
    path: key,
  });
  // console.log(key);
};
const loginSubmit = () => {
  if (my.value === "点击登录") {
    router.push({
      path: "/user/login",
    });
  }
};
const loginOut = () => {
  if (my.value !== "点击登录") {
    MyAxios.post("/user/logout").then((res) => {
      if (res.data.code === 0) {
        message.success("注销成功！");
      } else {
        message.error("注销失败：" + res.data.message);
      }
    });
  }
};
const toUserIndex = () => {
  if (my.value !== "点击登录") {
    router.push({
      path: "/info/index",
      query: {
        id: store.state.user?.loginUser?.id || -1,
      },
    });
  } else {
    message.warning("请先登录!");
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_doption = _resolveComponent("a-doption")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_row, {
    id: "globalHeader",
    align: "center",
    wrap: false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, { flex: "auto" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_menu, {
            mode: "horizontal",
            theme: "light",
            "selected-keys": selectedKeys.value,
            onMenuItemClick: doMenuClick
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_menu_item, {
                key: "0",
                style: { padding: 0, marginRight: '38px' },
                disabled: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleRoutes.value, (item) => {
                return (_openBlock(), _createBlock(_component_a_menu_item, {
                  key: item.path
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["selected-keys"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_col, {
        flex: "100px",
        onClick: loginSubmit,
        style: {"margin-right":"40px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_dropdown, { trigger: "hover" }, {
            content: _withCtx(() => [
              _createVNode(_component_a_doption, { onClick: loginOut }, {
                default: _withCtx(() => [
                  _createTextVNode("注销")
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_button, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(my.value), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})